import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      toast.success(data.message || "Correo enviado");
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8">
          <ArrowLeft className="w-4 h-4" /> Volver al inicio de sesión
        </Link>
        <div className="bg-black/60 backdrop-blur-xl border border-white/10 rounded-2xl p-10">
          <div className="w-12 h-12 rounded-xl border border-[#D4AF37]/40 grid place-items-center mb-6">
            <Mail className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl text-white mb-2">Recuperar contraseña</h1>
          <p className="text-zinc-400 text-sm mb-8">
            Introduce el email de tu cuenta y te enviaremos un enlace para restablecerla.
          </p>

          {sent ? (
            <div className="text-sm text-zinc-300 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-4" data-testid="forgot-sent">
              Si ese email existe, recibirás un correo con instrucciones en unos minutos. Revisa también tu carpeta de spam.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
              <div>
                <label className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-2 block">Email</label>
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email"
                  className="w-full bg-transparent border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#D4AF37] focus:outline-none"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit"
                className="w-full py-3 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#FDE047] transition-colors disabled:opacity-60"
              >
                {loading ? "Enviando…" : "Enviar enlace"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
